function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "0%",
  x2: "100.001%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFCA00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF8F00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: "100.002%",
  x2: "-.001%",
  y1: "50.001%",
  y2: "50.001%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFCA00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF8F00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: ".003%",
  x2: "99.998%",
  y1: "50.001%",
  y2: "50.001%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFCA00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF8F00"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M0 14.377V1.597C0 .716.715 0 1.598 0h12.779c.883 0 1.597.715 1.597 1.598v12.779c0 .883-.714 1.597-1.597 1.597H1.597A1.597 1.597 0 0 1 0 14.377z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M13.259 7.987a5.27 5.27 0 0 1-5.272 5.272 5.27 5.27 0 0 1-5.271-5.272 5.27 5.27 0 0 1 5.271-5.271 5.27 5.27 0 0 1 5.272 5.271z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M3.834 7.987a4.154 4.154 0 0 1 8.307 0 4.154 4.154 0 0 1-8.307 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.524 6.39a.567.567 0 0 0-.333.11l-1.747.851a.833.833 0 0 0-1.071-.027L5.685 6.5a.562.562 0 0 0-.896.453V9.02a.563.563 0 0 0 .896.452l1.688-.823c.143.11.322.18.518.18a.848.848 0 0 0 .553-.208l1.747.851a.562.562 0 0 0 .896-.452V6.955a.563.563 0 0 0-.563-.566z"
}));

var SvgMobileWaiter = function SvgMobileWaiter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileWaiter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobileWaiter.ed6eb53e.svg";
export { ForwardRef as ReactComponent };